 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"main": 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "vendors." + {"0":"96a4796f8cf18c9b1e00","1":"db300b19b59682ec4aa3","2":"0e85616be26fdbc8af64","3":"ddf1f7159dec0812bcbd","4":"fe4a824e2cb281d562a6","5":"603705054bc0e20914cb","6":"8ceced912573d96e173a","7":"8569b3c64067bd2a719d","vendors~Comment~ShareComment":"248c4c5b08808cff7301","vendors~Comment~Survey":"7621e12a03c9527e1d2f","vendors~Comment~LoginDialog":"0f93e7842df8a2389c44","Comment":"1d55c32af87267a5d1bd","vendors~Player":"46573466cdf9f1bdb17f","AccountOpening":"74da39f02c54a5962a94","BackTopBottom":"ab84a614d15c318b0667","Caption":"57bb5587eb791d6ba9c6","Copyright":"e93c50442a9fa6b0f07c","DataBox":"b3b86f76c3246b85cdf8","Img":"ceb3ef7599d71828a7db","LivePlayer":"7de1b0f87bc0d9d01d69","MoreTabs":"dfb756ed7c633f1490e7","Nav":"e2cf46ef7a11866c56bb","NormalCaption":"ab0e7da54e62906e5274","Offline":"c80e34c623cc5f70e704","QQShare":"e8a5f750851c0be01a27","SimpleGuideLayer":"1d2e72b32b86bdb5eb02","Stick":"d26b8b9a45a20e833235","Tip":"fd2023d2e396e68d27f7","ViewMoreLink":"808baee28046412491d4","vendors~Atlas~FiveNavPic~FourNavPic~InformationFlow~MdBanner~ThreeNavPic":"8d0e185c6e7c8464e0d5","Atlas":"450ae0fe72ad610514de","FiveNavPic":"69206c35f06f4561d850","FourNavPic":"1eccfba19e1e56cc7eff","vendors~MdBanner":"fe14d9df34c7643e3e2f","vendors~BigImage~BigImg~BigTopic~BottomSlides~CallupHead~CallupVideoAppHead~HomeFooter~Hongbao~Index~9c339333":"90a4a3dff7c25848dc8b","CallupVideoAppHead":"8ce9017375b075a2a8be","HomeFooter":"f16c9ba523e4fdd10b01","Hongbao":"bde664dbed5bce90a948","TwoImage":"bfb7089f2f1867f2cdb2","ThreeNavPic":"ac7d23c088118667651f","vendors~BigImage~NewsStream~NoImage~OneImage~ThreeImage":"cdb4624944ca84fe8780","BigImage":"6777673f02f75c3e07ad","NoImage":"f767868bd67946a23566","OneImage":"b52a7c149ac70503fb8d","ThreeImage":"aabaff668c68905377a7","vendors~NewsStream":"55557624707ee716b14a","vendors~BigImg~BigTopic~InformationFlow~SingleTitle~SlideImg~TitleImg~TwoImg":"f777c7769138ad8169d5","BigImg":"18f5228b3f463c62f51f","SingleTitle":"c458ebd6a7f9dafdda5d","SlideImg":"6c6a639b7485d5bd7edb","TwoImg":"76b70fce7945ee9eed92","vendors~BigTopic~InformationFlow~TitleImg":"daa59cdb98beca983727","InformationFlow":"63c99f8ebd1640508adc","BigTopic":"515bee3fc0b2d10909cf","TitleImg":"12e55348a4016e827b8c","vendors~BottomSlides~IndexSlides~NormalSlides~ShareSlides~Slides~UpgradeBottomSlides":"96d67f888c68ee657843","BottomSlides":"959851bab849bca45329","IndexSlides":"de7dd578b5632e9eca92","NormalSlides":"ac525cf20f89932e46a8","ShareSlides":"d2338d866022c7cef684","vendors~UpgradeBottomSlides":"adca68fbcbdac2abf1cd","vendors~CallupHead":"bc6d6cc24877bb8ea14b","vendors~ShareComment":"dcdd3bd455fd0bf8efb6","vendors~Survey":"7b1b6bcec1519be523eb","vendors~NormalTabs":"7442b1efa30cde10e4d9","vendors~WXGuideLayer":"e284e98668d0ec9ff544","LoginDialog":"94396db2ed550aea9fb1","vendors~MarkTabs":"616ae459223202d94601","vendors~SlidesTabs":"0d63bba037cda67490b4"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://x2.ifengimg.com/fe/shank/list/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 0);
